/* eslint-disable no-console */
import { __rest } from "tslib";
/**
 * @param  {string} message - The error message to log
 * @param  {any} errorInstance - Optional error instance
 * @returns void
 */
const error = (message, errorInstance) => {
    const isDev = process.env.NODE_ENVIRONMENT === 'development';
    const type = isDev ? 'error' : 'warn';
    const color = isDev ? '#EC3941' : '#F5BD01';
    console[type](`%c %c ${message}`, `color: white; background: ${color}; font-size: 14px;`, 'color: reset; background: transparent;', '\n\n', errorInstance);
};
/**
 * @param  {Request} request - The request object
 * @return LoggerData
 */
const getLoggerData = ({ request, message }) => {
    var _a, _b;
    const { LOGGER_REQUEST_IP_HEADER_KEY = '', LOGGER_JIRA_TEAM = '', LOGGER_SERVICE_NOW_ID = '', LOGGER_APP_NAME = '', LOCALE_PREFIX = '', NEXT_PUBLIC_BRAND = '', COUNTRY_ISO_CODE = '', } = process.env;
    const requestIp = LOGGER_REQUEST_IP_HEADER_KEY
        ? ((_a = request === null || request === void 0 ? void 0 : request.headers) === null || _a === void 0 ? void 0 : _a[LOGGER_REQUEST_IP_HEADER_KEY]) || ''
        : '';
    const { requestAction, requestUri, requestMethod, responseStatus, stackTrace, deviceType } = message, data = __rest(message, ["requestAction", "requestUri", "requestMethod", "responseStatus", "stackTrace", "deviceType"]);
    return Object.assign(Object.assign({ response_status: responseStatus, request_action: requestAction || '', request_uri: requestUri || '', request_method: requestMethod || '', request_ip: requestIp, deviceType: deviceType || '', touch_point: ((_b = request === null || request === void 0 ? void 0 : request.body) === null || _b === void 0 ? void 0 : _b.touchPoint) || '', app_name: LOGGER_APP_NAME, locale: LOCALE_PREFIX, brand: NEXT_PUBLIC_BRAND, market: COUNTRY_ISO_CODE, jira_team: LOGGER_JIRA_TEAM, snow_id: LOGGER_SERVICE_NOW_ID }, (stackTrace && {
        stackTrace,
    })), data);
};
/**
 * Please use this for server side, on client side you may get error intentional
 * @param  {any} message - The error message to log
 * @returns void
 */
export const splunkReadableError = (message, request) => {
    const errorMsg = Object.assign({ severity: 'ERROR', type: 'ERROR', level: 'ERROR', time: `${new Date().toUTCString()}` }, getLoggerData({ request, message }));
    function print() {
        setImmediate(() => {
            process.stdout.write(`${JSON.stringify(errorMsg)}\n`);
        });
    }
    print();
};
/**
 * Please use this for server side, on client side you may get error intentional
 * @param  {any} message - The info message to log
 * @returns void
 */
export const splunkReadableInfo = (message, request) => {
    const errorMsg = Object.assign({ severity: 'INFO', type: 'INFO', level: 'INFO', time: `${new Date().toUTCString()}` }, getLoggerData({ request, message }));
    function print() {
        setImmediate(() => {
            process.stdout.write(`${JSON.stringify(errorMsg)}\n`);
        });
    }
    print();
};
/**
 * @param  {Array<string | Object>} args - The warning message to log
 * @returns void
 */
const warn = (...args) => {
    console.warn(...args);
};
/**
 * @param  {Array<string | Object>} args - The log message to log
 * @returns void
 */
const log = (...args) => {
    console.log(...args);
};
/**
 * @param ...messages - Any number of params with strings or objects
 * @returns void
 */
const info = (...messages) => {
    messages.forEach((message) => {
        if (typeof message === 'string') {
            console.trace(`%c %c ${messages}`, 'color: white; background: blue; font-size: 14px;', 'color: reset; background: transparent;');
        }
        else if (typeof message === 'object') {
            console.trace(`%c %c ${messages}`, 'color: white; background: blue; font-size: 14px;', 'color: reset; background: transparent;');
        }
    });
};
const consoleEvents = {
    error,
    info,
    warn,
    log,
    splunkReadableError,
    splunkReadableInfo,
};
export default consoleEvents;
//# sourceMappingURL=consoleEvents.js.map